module.exports = __webpack_public_path__ + "img/xk.xk06ff301.svg";